<template>
  <div>
    <div v-if="message.success">
      <div class="alert alert-info" role="alert">
        {{ message.success }}
      </div>
    </div>
    <form class="margin-bottom-0" method="post" action="#" v-if="!message.success">
      <div class="alert alert-danger" role="alert" v-show="message.error">
        {{ message.error }}
      </div>
      <div class="form-group m-b-15">
        <input type="text" class="form-control form-control-lg" name="email" id="email" v-model="email" placeholder="Enter your Email" :class="{'is-invalid': $v.email.$error}" @input="$v.email.$touch()" @keyup.enter="sendSignUp()"/>
        <div v-if="$v.email.$error" class="invalid-feedback">Email is not valid.</div>
      </div>

      <div class="form-group m-b-15">
        <input type="password" class="form-control form-control-lg" name="password" id="password" v-model="password" placeholder="Enter your Password" :class="{'is-invalid': $v.password.$error}" @input="$v.password.$touch()" @keyup.enter="sendSignUp()"/>
        <!-- <div v-if="$v.password.$error" class="invalid-feedback">Password is not valid.</div> -->
      <div v-if="$v.password.$error" :class="{'invalid-feedback': !$v.password.minLength}">Password min length is 6</div>
      </div>

      <div class="form-group m-b-15">
        <input type="password" class="form-control form-control-lg" name="confirm" id="confirm" v-model="confirmPassword" placeholder="Confirm your Password" :class="{'is-invalid': $v.confirmPassword.$error}" @input="$v.confirmPassword.$touch()" @keyup.enter="sendSignUp()"/>
        <div v-if="$v.confirmPassword.$error" class="invalid-feedback">This password is not the same.</div>
      </div>

      <div class="login-buttons">
        <button type="button" class="btn btn-primary get-started  rounded-pill btn-block" style="width: 100%; padding: 10px 16px; font-size: 18px;" @click.stop.prevent="sendSignUp()">Register</button>
      </div>
      <div class="m-t-20 m-b-40 p-b-40 text-inverse">
        Already have an account? Click <router-link class="text-theme" :to="{ name: 'Login'}">here</router-link> to login.
      </div>
    </form>
  </div>
</template>


<script>
import Vuex from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'SignUp',
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(6) },
    confirmPassword: { required, sameAsPassword: sameAs('password') }
  },
  data() {
    return {
      message: {
        success: false,
        error: false
      },
      ok: null,
      email: null,
      password: null,
      confirmPassword: null
    }
  },
  methods: {
    ...Vuex.mapActions(['signUp', 'startLoading', 'endLoading']),
    hideErrorMessage() {
      this.message.error = null
    },
    showErrorMessage(message) {
      this.message.error = message
    },
    showSuccessMessage(message) {
      this.message.success = message
    },
    sendSignUp: function() {
      this.hideErrorMessage()
      let self = this
      if (!this.$v.$invalid) {
        this.startLoading()
        this.signUp({
          email: this.email,
          password: this.password
        })
          .then(() => {
            self.showSuccessMessage('Thanks for signing up. Please check your email for confirmation!')
          })
          .catch((err) => {
            try {
              let errMsgObj = JSON.parse(err.message)

              if (errMsgObj.message === 'signUp.email.alreadyUsed') {
                errMsgObj.messageText = 'The email address you have entered is already registered'
              } else {
                errMsgObj.messageText = 'Sorry but an error occurred when submitting form'
              }
              this.showErrorMessage(errMsgObj.messageText)
            } catch (error) {
              console.log(error)
            }
          })
          .finally(() => {
            this.endLoading()
          })
      } else {
        this.showErrorMessage('Form is not valid, please fill all fields following requirements')
      }
    }
  }
}
</script>
<style>
.m-b-15 {
  margin-bottom: 15px !important;
}
.m-t-20 {
  margin-top: 20px !important;
}
.m-b-40 {
  margin-bottom: 40px !important;
}
.p-b-40 {
  padding-bottom: 40px !important;
}
.text-grey-darker {
    color: #929ba1!important;
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/SignUp.vue